import Vue from 'vue'
import Router from 'vue-router'
import user from './user'
import admin from './admin'

Vue.use(Router)
    //解决跳转时push了相同的地址
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

export default new Router({
    // mode: 'history',
    routes: [
        ...user,
        ...admin,
        {
            path: '/500',
            component: (resolve) => require(['../view/500.vue'], resolve),
            name: 'notfind',
        },
        {
            path: '/error',
            component: (resolve) => require(['../view/error.vue'], resolve),
            name: 'notfind',
        },

        { //没有找到该页面
            path: '*',
            component: (resolve) => require(['../view/notfind.vue'], resolve),
            name: 'notfind',
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js